import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconChevronTop"><Path fillRule="evenodd" clipRule="evenodd" d="M12.1768 8.23753C12.0791 8.1399 11.9208 8.1399 11.8232 8.23753L4.53033 15.5304C4.23744 15.8233 3.76256 15.8233 3.46967 15.5304C3.17678 15.2375 3.17678 14.7627 3.46967 14.4698L10.7625 7.17687C11.446 6.49345 12.554 6.49345 13.2374 7.17687L20.5303 14.4698C20.8232 14.7627 20.8232 15.2375 20.5303 15.5304C20.2374 15.8233 19.7626 15.8233 19.4697 15.5304L12.1768 8.23753Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTop;
